import {debounce} from './utilities';

const isInView = (element) => {
    const position = element.getBoundingClientRect();

    // checking whether fully visible
    if ((position.top >= 0 && position.bottom <= window.innerHeight) || (position.top < window.innerHeight && position.bottom >= 0)) {
        return true;
    }

    return false;
};

class PrimaryNav extends HTMLElement {
    static threshold = 0;
    static observedAttributes = ['open'];

    constructor() {
        super();

        this.links = [...this.querySelectorAll('a')];
        this.btn = this.querySelector('.primary-nav-btn');
        // this.btnText = this.btn.querySelector('[data-element="primary-nav-text"]');
        this.primaryNavList = this.querySelector('.primary-nav-list');

        // Cast open attribute to a Boolean, so !this.open works correctly
        this.open = this.getAttribute('open') === 'true' ? true : false;
        this.buildTl();

        // get media query from custom property
        const rootStyle = getComputedStyle(document.documentElement);
        this.maxQuery = rootStyle.getPropertyValue('--max-nav-media-query');
        this.minQuery = rootStyle.getPropertyValue('--min-nav-media-query');

        this.initialized = false;
    }

    connectedCallback() {
        this.observeSections();
        this.onWindowResize();
        this.bindEvents();

        const sections = [...document.querySelectorAll('section-anchor')];

        sections.forEach((element) => {
            if (isInView(element)) {
                this.setCurrentLink(element);
            }
        });
    }

    // attributeChangedCallback(name, _oldValue, newValue) {
    //     // do gsap animations here
    //     if (name === 'open' && newValue === true) {
    //         // nav is open
    //         // this.tl.play(0);
    //     } else {
    //         // nav is closed
    //         // this.tl.reverse();
    //     }
    // }

    bindEvents() {
        this.addEventListener('click', (event) => this.onClick(event));
        this.btn.addEventListener('click', () => this.mobileBtnClick());
        this.bindMediaQuery();
    }

    bindMediaQuery() {
        // max nav - mobile
        this.maxMediaQuery = window.matchMedia(this.maxQuery);
        this.maxMediaQuery.addEventListener('change', this.onMaxMediaChange.bind(this));
        this.onMaxMediaChange(this.maxMediaQuery);

        // min nav - desktop
        this.minMediaQuery = window.matchMedia(this.minQuery);
        this.minMediaQuery.addEventListener('change', this.onMinMediaChange.bind(this));
        this.onMinMediaChange(this.maxMediaQuery);
    }

    onMaxMediaChange(mobileMediaQuery) {
        // mobile
        if (mobileMediaQuery.matches) {
            this.mobile = true;
            this.desktop = false;
            this.opened = false;
            gsap.set(this.primaryNavList, {clearProps: true});
        }
    }

    onMinMediaChange(desktopMediaQuery) {
        // desktop
        if (desktopMediaQuery.matches) {
            this.desktop = true;
            this.mobile = false;
            this.opened = false;

            gsap.set(this.primaryNavList, {clearProps: true});
        }
    }

    buildTl() {
        this.tl = gsap.timeline({
            ease: 'sine.out',
            duration: 0.2,
            paused: true,
        });

        this.tl.to(this.primaryNavList, {
            display: 'flex',
            opacity: 1,
        }, 0);
        // .to(this.btn, {
        //     width: '100%',
        // }, '<').to(this, {
        //     width: '80%',
        // }, '<');
    }

    onClick(event) {
        const element = event.target.closest('a');
        if (element) {
            this.open = false;
            this.setAttribute('open', this.open);
            this.tl.reverse();
        }
    }

    mobileBtnClick() {
        this.open = !this.open;
        this.setAttribute('open', this.open);

        if (this.open) {
            this.tl.play(0);
        } else {
            this.tl.reverse();
        }
    }

    setCurrentLink(element) {
        let currentLinkIndex;

        this.links.forEach((link, index) => {
            if (link.href.indexOf('#') != -1 && link.href.substr(link.href.indexOf('#')).slice(1) === element.id) {
                currentLinkIndex = index;
            }
        });

        this.links.forEach((link, index) => {
            if (index < currentLinkIndex) {
                link.classList.add('is-seen');
            }

            if (index === currentLinkIndex) {
                const right = this.getBoundingClientRect().width - link.getBoundingClientRect().right;

                link.classList.remove('is-seen');
                link.classList.add('is-active');

                if (this.initialized) {
                    gsap.to('primary-nav .bg', {
                        ease: 'sine.out',
                        right,
                    });
                } else {
                    gsap.set('primary-nav .bg', {
                        right,
                    });

                    gsap.to('primary-nav .bg', {
                        opacity: 1,
                    });

                    this.initialized = true;
                }

                // this.btnText.innerHTML = link.innerHTML;
            }

            if (index > currentLinkIndex) {
                link.classList.remove('is-active');
                link.classList.remove('is-seen');
            }
        });
    }

    onWindowResize() {
        window.addEventListener('resize', debounce(() => {
            document.querySelectorAll('section-anchor').forEach((element) => {
                if (isInView(element)) {
                    this.setCurrentLink(element);
                }
            });
        }, 250));
    }

    observeSections() {

        let rootMarginValue = '-40% 0px -60% 0px'; // Default for this page

        // Check the page URL
        if (window.location.pathname.includes('/people')) {
            rootMarginValue = '0% 0px 0% 0px'; // Apply old rootMargin for other pages
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    console.log(`Section intersecting: ${entry.target.id}`);
                    this.setCurrentLink(entry.target);
                }
            });
        }, {
            rootMargin: rootMarginValue,
            threshold: 0,
        });
        document.querySelectorAll('section-anchor').forEach((section) => {
            observer.observe(section);
        });
    }
}

customElements.define('primary-nav', PrimaryNav);
